import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { WbScreenTabs } from './WbScreenTabs'
import { WbLoadOrdersForm } from './WbLoadOrdersForm'
import { WbOrdersSupplyDropdown } from './WbOrdersSupplyDropdown'
import { OrdersTableTab, StoreOrdersScreen } from './StoreOrdersScreen'

import { useLogic, useStore } from '../hooks/storeHook'

import { WbAccountProps } from '../types/accountProps'
import { createWbOrderColumns } from '../types/wbOrderColumns'

import { WbDeliveryType } from '../server/mpsklad_core/Entity/Wildberries/WbDeliveryType'

export const WbOrdersTabsScreen = () =>
  <WbScreenTabs ScreenComponent={WbOrdersScreen}/>

export const WbOrdersScreen =
  observer(
    ({account}: WbAccountProps) => {
      const {api, wbOrderLoaders} = useLogic()
      const {orderStore: {createWbOrdersTable}} = useStore()

      const wbOrderColumns = useMemo(
        () => createWbOrderColumns(account),
        [account])

      const wbOrders = useMemo(
        () => createWbOrdersTable(account.id),
        [createWbOrdersTable, account])

      useEffect(() => wbOrderLoaders.addHandler(wbOrders.load), [wbOrderLoaders, wbOrders])

      const tabs = useMemo(() => {
          const commonTabs =
            [OrdersTableTab.Active, OrdersTableTab.Cancelled, OrdersTableTab.WithErrors] as const

          return account.deliveryType === WbDeliveryType.FBW
                 ? [...commonTabs, OrdersTableTab.LoadOrders] as const
                 : commonTabs
        },
        [account.deliveryType])

      const searchPlaceholder = useMemo(() => {
          const searchFields = ['Id', 'Id в Wildberries']

          if (account.deliveryType === WbDeliveryType.FBW) {
            searchFields.push('Уникальный идентификатор заказа (FBW)')
          }

          return [...searchFields, 'Код размера (chrtId)', 'Идентификатор вещи', 'Штрихкод'].join(' / ')
        },
        [account.deliveryType])

      return (
        <StoreOrdersScreen
          account={account}
          tabValues={tabs}
          orders={wbOrders}
          columns={wbOrderColumns}
          searchPlaceholder={searchPlaceholder}
          pullOrdersWithErrors={api.order.pullWbOrdersWithErrors}
          exportOrdersToExcel={api.order.exportWbToExcel}
          LoadOrdersFormComponent={WbLoadOrdersForm}
          AfterSearchActiveComponent={WbOrdersSupplyDropdown}
        />
      )
    })